import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'
import { motion } from 'framer-motion'

import useElementSize from '@/hooks/useElementSize'

import { Button } from '@/components/UI/Button'
import { Card } from '@/components/UI/Card'

import './Faq.scss'

const cnFaq = cn('Faq')

interface FaqProps {
  className?: string
}

export const Faq: FC<FaqProps> = ({ className }: FaqProps): JSX.Element => {
  const [active, setActive] = useState<number | null>(null)
  const { width } = useElementSize()
  const { t } = useTranslation()

  const toggleAccordion = (index: number) => {
    setActive(active === index ? null : index)
  }

  const arr = [
    {
      title: t('landing-faq-title-1'),
      text: t('landing-faq-text-1'),
    },
    {
      title: t('landing-faq-title-2'),
      text: t('landing-faq-text-2'),
    },
    {
      title: t('landing-faq-title-3'),
      text: t('landing-faq-text-3'),
    },
  ]

  return (
    <div className={cnFaq(null, [className])}>
      <div className={cnFaq('title')}>
        <span>Frequently asked</span> <br /> questions
      </div>

      <div className={cnFaq('list')}>
        {arr.map((el, i) => (
          <Card key={i} className={cnFaq('item')}>
            <div className={cnFaq('top')}>
              <div className={cnFaq('subtitle')}>{el.title}</div>
              {!!width && width > 768 && (
                <Button
                  color='light'
                  onClick={() => toggleAccordion(i)}
                  icon
                  className={cnFaq('btn')}
                >
                  {active === i ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 448 512'
                    >
                      <path
                        fill='#1A93E4'
                        d='M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z'
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 18 18'
                      fill='none'
                    >
                      <path
                        d='M3 9H15M9 3V15'
                        stroke='#1A93E4'
                        stroke-width='1.5'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                  )}
                </Button>
              )}
            </div>

            {active === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={
                  active === i
                    ? { height: 'auto', opacity: 1 }
                    : { height: 0, opacity: 0 }
                }
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                style={{ overflow: 'hidden' }}
                className={cnFaq('text')}
              >
                {el.text}
              </motion.div>
            )}

            {!!width && width <= 768 && (
              <Button
                color='light'
                onClick={() => toggleAccordion(i)}
                icon
                className={cnFaq('btn')}
              >
                {active === i ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 448 512'
                  >
                    <path
                      fill='#1A93E4'
                      d='M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z'
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 18 18'
                    fill='none'
                  >
                    <path
                      d='M3 9H15M9 3V15'
                      stroke='#1A93E4'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                )}
              </Button>
            )}
          </Card>
        ))}
      </div>
    </div>
  )
}
